// extracted by mini-css-extract-plugin
export default {"tooltip":"Map_tooltip__fBz1I","tooltipTitle":"Map_tooltipTitle__RtSN7","tooltipText":"Map_tooltipText__hMwxY","tooltipBadge":"Map_tooltipBadge__q50KP"};